export class AuthUnicornConfig {
  baseUrl!: string;
  refreshTokenLifespan!: number;
  publicBaseUrl!: string;
}
